import React, { useState, Fragment, useEffect } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardHeader,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";

import { useQuery } from "@apollo/client";

import { GET_MARKET_DATA } from "../../../queries";
import TransitionGraph1 from "./Modules/TransitionGraph1";
import TransitionGraph2 from "./Modules/TransitionGraph2";
import TransitionGraph3 from "./Modules/TransitionGraph3";

import InfoTable from "../../Tables/InfoTable";
import animetionLogo from "../../../assets/utils/images/animetion_logo.gif";
import { sendGAEvent } from "../../../utils";
// import InterestQuestionnaire from "../../InterestQuetionnaire/index";

/**
 * マーケット推移ページ
 * @returns
 */

const MarketDashboard = ({ userMail }) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  //クエリ取得
  const { loading, error, data } = useQuery(GET_MARKET_DATA);

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );
  if (error) {
    // alert("ログイン制限時間が切れました、再リロードしてください。");
    alert(error.message);
    window.location.href = "/market";
  }
  if (!data) return "...Not Found";

  const graphData = data.market.edges;
  const orgListData = data.allOrgaccount.edges.map((array) => array.node);

  return (
    <div>
      <Fragment>
        <CSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Card className="mb-3">
            <CardHeader className="card-header-tab">
              <Nav>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    マーケット推移
                  </NavLink>
                </NavItem>
                {/* ↓残しておいて 22.5.25 */}
                {/* <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    プロジェクト推移
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      sendGAEvent(
                        "pageview",
                        "/#/dashboards/market/establish_trend_tab"
                      );
                      toggle("3");
                    }}
                  >
                    設立数推移
                  </NavLink>
                </NavItem>
              </Nav>
            </CardHeader>
            <TabContent activeTab={activeTab} className="card-tab-inner">
              <TabPane tabId="1">
                <Row>
                  <Col sm="12">
                    <TransitionGraph1 graphData={graphData} />
                  </Col>
                </Row>
              </TabPane>
              {/* ↓プロジェクト推移 残す 22.5.25 */}
              {/* <TabPane tabId="2">
                <Row>
                  <Col sm="12">
                    <TransitionGraph2 graphData={graphData} />
                  </Col>
                </Row>
              </TabPane> */}
              <TabPane tabId="3">
                <Row>
                  <Col sm="12">
                    <TransitionGraph3 graphData={graphData} />
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Card>

          <InfoTable orgListData={orgListData} title="組織リスト" />
        </CSSTransitionGroup>
      </Fragment>
    </div>
  );
};

export default MarketDashboard;
